import React, { useCallback } from 'react';
import {
  TableBodyPropGetter,
  TableBodyProps,
  Row,
  ColumnInstance,
} from 'react-table';

import { shouldTreatSuggestedAsCompositionOriginal } from 'shared/budget-component-type';

import { Tbody, Tr } from '@chakra-ui/react';

import Loader from 'components/Loader';
import { Td } from 'components/Table';

import CompositionCustomRow from './CompositionCustomRow';
import CompositionRow from './CompositionRow';
import InputRow from './InputRow';
import { FlattenedComponent, Stage } from './types';

type RowType = Stage['type'];

interface ComponentsBodyProps {
  getTableBodyProps: (
    propGetter?: TableBodyPropGetter<FlattenedComponent> | undefined,
  ) => TableBodyProps;
  loading: boolean;
  data: FlattenedComponent[];
  rows: Row<FlattenedComponent>[];

  visibleColumns: ColumnInstance<FlattenedComponent>[];
  prepareRow: (row: Row<FlattenedComponent>) => void;

  onUpdateComponentBDI: (id: number, bdi: number | undefined) => void;
}

const ComponentsTableBody: React.FC<ComponentsBodyProps> = ({
  getTableBodyProps,
  loading,
  data,
  rows,
  prepareRow,
  onUpdateComponentBDI,
}) => {
  const getRow = useCallback(
    (type: RowType, row: Row<FlattenedComponent>) => {
      if (
        shouldTreatSuggestedAsCompositionOriginal({
          type,
          total: row.original.total,
        })
      ) {
        return (
          <CompositionRow
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            row={row as any}
            data={data}
            onUpdateComponentBDI={onUpdateComponentBDI}
            {...row.getRowProps()}
          />
        );
      }

      if (type === 'input_original') {
        return (
          <InputRow
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            row={row as any}
            data={data}
            onUpdateComponentBDI={onUpdateComponentBDI}
            {...row.getRowProps()}
          />
        );
      }

      if (type === 'composition_custom') {
        return (
          <CompositionCustomRow
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            row={row as any}
            onUpdateComponentBDI={onUpdateComponentBDI}
            {...row.getRowProps()}
          />
        );
      }

      return null;
    },
    [data, onUpdateComponentBDI],
  );

  return (
    <Tbody {...getTableBodyProps()}>
      {(!loading || data.length >= 0) &&
        rows.map((row) => {
          prepareRow(row);
          return getRow(row.original.type, row);
        })}

      {loading && (
        <Tr>
          <Td columnKey={1} colSpan={1000} paddingY={4}>
            <Loader />
          </Td>
        </Tr>
      )}

      {!loading && data.length === 0 && (
        <Tr>
          <Td columnKey={1} colSpan={1000} paddingY={4}>
            Nenhum item encontrado
          </Td>
        </Tr>
      )}
    </Tbody>
  );
};

export default ComponentsTableBody;
